module.exports = __webpack_public_path__ + "assets/img/gzinfo.46db4b97.png";